import { useEffect } from 'react';
// import { formatUnits, parseUnits } from 'ethers/lib/utils';
import { useWeb3React } from '@web3-react/core';
import useSWR from 'swr';
// import { ITradePairHelper__factory } from '../../../config/contracts/typechain';
import useTokenDetails from '../useTokenDetails';
import { config } from '../../../config/config';
import {
    // CHAIN_INFO,
    EnabledChains,
    // OrderBookType,
    // OrderDataTypes,
    // ResStatus,
    // Trader,
} from '../../../config/constants';
import {
    sleep,
    verifyChainConfig,
    //  subgraphQuery
} from '../../../helpers';
import useDelayLoading from '../../useDelayLoading';
// import { ClosePositionParamsStruct } from '../../../config/contracts/typechain/ITradeManager';
// import { BigNumber, ethers } from 'ethers';
import useTradePools from './useTradePools';
import { TradePair } from '../../../context/chart/chartTypes';
import moment from 'moment';
import useUserPositionIds from './useUserPositionIds';

export type UserPosition = {
    tradePair: TradePair;
    id: string;
    margin: string;
    volume: string;
    size: string;
    leverage: string;
    entryLeverage: string;
    isShort: boolean;
    entryPrice: string;
    entryMargin: string;
    bankruptcyPrice: string;
    pnl: string;
    pnlPercent: string;
    pnlGross: string;
    pnlGrossPercent: string;
    pnlFeePercent: string;
    totalFeeAmount: string;
    borrowFee: string;
    fundingFee: string;
    openedTimestamp: number;
    tpsl: {
        takeProfit:
            | {
                  price: string;
                  orderId: string;
              }
            | undefined;
        stopLoss:
            | {
                  price: string;
                  orderId: string;
              }
            | undefined;
    };
};

export type UserPositionRaw = Omit<
    UserPosition,
    'pnl' | 'pnlPercent' | 'pnlGross' | 'pnlGrossPercent' | 'pnlFeePercent'
>;

let initialLoadUp = false;

const useUserPositions = () => {
    const {
        // account,
        chainId,
        // library
    } = useWeb3React();

    const { tradePools } = useTradePools();

    const {
        // userPositionIds,
        error: userPositionIdsError,
    } = useUserPositionIds();

    const delayComplete = useDelayLoading();

    const {
        //  decimals,
        error: tokenDetailsError,
    } = useTokenDetails(config.addresses[chainId as EnabledChains[number]]?.collateral);

    const { data, error, mutate } = useSWR(
        // account && tradePools && decimals && chainId && library && userPositionIds
        tradePools && chainId
            ? [
                  'userPositionsRaw',
                  //   account,
                  tradePools,
                  //   decimals,
                  chainId,
                  //   library,
                  //   userPositionIds,
              ]
            : null,
        async (
            _,
            // userAddress,
            tradePools,
            // decimals,
            chainId
            // library,
            // userPositionIds
        ): Promise<UserPositionRaw[] | undefined> => {
            if (!verifyChainConfig(chainId)) return;

            // const provider = CHAIN_INFO[chainId].rpcUrls[0]
            //     ? new ethers.providers.JsonRpcProvider(CHAIN_INFO[chainId].rpcUrls[0])
            //     : library;

            // //  fetch all positions using loop
            // const query = `
            //       traders(where: {user: "${userAddress.toLowerCase()}"}) {
            //         positions(where: {status_not_in: ["CLOSED", "LIQUIDATED"]}) {
            //             id
            //             entryMargin
            //             openedTimestamp
            //             tradePair {
            //                 id
            //             }
            //         }
            //       }
            // `;

            // const data: { traders: Pick<Trader, 'positions'>[] } = await subgraphQuery(
            //     query,
            //     { chainId }
            // );

            // const subgraphUserPositions = data.traders?.[0]?.positions ?? [];

            // const res = await fetch(
            //     `${
            //         config.endpoints[chainId].orderBook
            //     }/orders/user/${userAddress.toLowerCase()}`
            // );

            // const orders: ResStatus = await res.json();

            // // getting TP/SL orders
            // const userOrders = orders.data
            //     .filter(
            //         ({ orderType, isMarketOrder, status }) =>
            //             orderType === OrderBookType.CLOSE &&
            //             !isMarketOrder &&
            //             status === 'requested'
            //     )
            //     .map(({ orderJson, id, type, isShort }) => {
            //         const orderData: OrderDataTypes<ClosePositionParamsStruct> =
            //             JSON.parse(orderJson);

            //         let price: BigNumber;

            //         if (type === OrderBookType.TAKE_PROFIT) {
            //             price = BigNumber.from(
            //                 orderData.constraints[isShort ? 'maxPrice' : 'minPrice']
            //             );
            //         } else if (type === OrderBookType.STOP_LOSS) {
            //             price = BigNumber.from(
            //                 orderData.constraints[isShort ? 'minPrice' : 'maxPrice']
            //             );
            //         } else {
            //             price = BigNumber.from(orderData.constraints.minPrice)
            //                 .add(BigNumber.from(orderData.constraints.maxPrice))
            //                 .div(2);
            //         }

            //         return {
            //             orderId: id,
            //             orderPositionId: orderData.params.positionId,
            //             price,
            //             tradePairAddress: orderData.params.tradePair
            //                 .toString()
            //                 .toLowerCase(),
            //             type,
            //         };
            //     });

            // const tradeHelperContract = ITradePairHelper__factory.connect(
            //     config.addresses[chainId].tradePairHelper,
            //     provider
            // );

            // const tradePairAddresses = tradePools.map(({ address }) => address);

            // const positionIdsByTradePair = Object.entries(userPositionIds).reduce(
            //     (acc, [tradePairId, positionIds]) => {
            //         const tradePairIndex = tradePairAddresses.indexOf(tradePairId);

            //         acc[tradePairIndex] = [...acc[tradePairIndex], ...positionIds];

            //         return acc;
            //     },
            //     [...new Array(tradePairAddresses.length)].map(() => []) as string[][]
            // );

            // const positions = await tradeHelperContract.detailsOfPositions(
            //     tradePairAddresses,
            //     positionIdsByTradePair
            // );

            // const userPositions = positions.flatMap((tradePairPositions, index) => {
            //     return tradePairPositions
            //         .filter((position) => !position.margin.isZero())
            //         .map((position) => {
            //             const tradePair = tradePools[index];

            //             const subgraphPosition = subgraphUserPositions.find(
            //                 ({ id }) =>
            //                     id === `${tradePair.address.toLowerCase()}-${position.id}`
            //             );

            //             const takeProfitOrder = userOrders.find(
            //                 ({ orderPositionId, tradePairAddress, type }) =>
            //                     orderPositionId === position.id.toString() &&
            //                     tradePair.address.toLowerCase() === tradePairAddress &&
            //                     type === OrderBookType.TAKE_PROFIT
            //             );

            //             const stopLossOrder = userOrders.find(
            //                 ({ orderPositionId, tradePairAddress, type }) =>
            //                     orderPositionId === position.id.toString() &&
            //                     tradePair.address.toLowerCase() === tradePairAddress &&
            //                     type === OrderBookType.STOP_LOSS
            //             );

            //             const entryMargin = subgraphPosition
            //                 ? subgraphPosition.entryMargin
            //                 : position.margin;

            //             return {
            //                 tradePair,
            //                 id: position.id.toString(),
            //                 margin: formatUnits(position.margin, decimals),
            //                 volume: formatUnits(position.volume, decimals),
            //                 size: formatUnits(position.assetAmount, 18),
            //                 leverage: formatUnits(position.leverage, decimals),
            //                 entryLeverage: formatUnits(
            //                     position.volume
            //                         .mul(parseUnits('1', decimals))
            //                         .div(entryMargin || '1'),
            //                     decimals
            //                 ),
            //                 isShort: position.isShort,
            //                 entryPrice: formatUnits(
            //                     position.entryPrice,
            //                     config.priceFeedDecimal
            //                 ),
            //                 entryMargin: formatUnits(entryMargin, decimals),
            //                 bankruptcyPrice: formatUnits(
            //                     position.entryPrice[position.isShort ? 'add' : 'sub'](
            //                         position.entryPrice
            //                             .mul(parseUnits('1', config.priceFeedDecimal))
            //                             .div(
            //                                 parseUnits(
            //                                     position.leverage.toString(),
            //                                     config.priceFeedDecimal - decimals
            //                                 )
            //                             )
            //                     ),
            //                     config.priceFeedDecimal
            //                 ),
            //                 totalFeeAmount: formatUnits(
            //                     position.currentBorrowFeeAmount.add(
            //                         position.currentFundingFeeAmount
            //                     ),
            //                     decimals
            //                 ),
            //                 borrowFee: formatUnits(
            //                     position.currentBorrowFeeAmount,
            //                     decimals
            //                 ),
            //                 fundingFee: formatUnits(
            //                     position.currentFundingFeeAmount,
            //                     decimals
            //                 ),
            //                 tpsl: {
            //                     takeProfit: takeProfitOrder
            //                         ? {
            //                               price: formatUnits(
            //                                   takeProfitOrder.price,
            //                                   config.priceFeedDecimal
            //                               ),
            //                               orderId: takeProfitOrder.orderId.toString(),
            //                           }
            //                         : undefined,
            //                     stopLoss: stopLossOrder
            //                         ? {
            //                               price: formatUnits(
            //                                   stopLossOrder.price,
            //                                   config.priceFeedDecimal
            //                               ),
            //                               orderId: stopLossOrder.orderId.toString(),
            //                           }
            //                         : undefined,
            //                 },
            //                 openedTimestamp: subgraphPosition?.openedTimestamp
            //                     ? subgraphPosition.openedTimestamp
            //                     : moment().unix(),
            //             };
            //         });
            // });

            return [
                {
                    tradePair: tradePools[0],
                    id: '1',
                    margin: '123',
                    volume: '456',
                    size: '789',
                    leverage: '10',
                    entryLeverage: '2',
                    isShort: false,
                    entryPrice: '4000',
                    entryMargin: '300',
                    bankruptcyPrice: '3600',
                    totalFeeAmount: '120',
                    borrowFee: '10',
                    fundingFee: '5',
                    tpsl: {
                        takeProfit: {
                            price: '4200',
                            orderId: 'abc123',
                        },
                        stopLoss: {
                            price: '3700',
                            orderId: 'abc12345',
                        },
                    },
                    openedTimestamp: moment().startOf('day').unix(),
                },
            ] as UserPositionRaw[];

            // return userPositions.sort((a, b) => b.openedTimestamp - a.openedTimestamp);
        },
        { dedupingInterval: 2000 }
    );

    const updateUserPositions = async (
        oldPositions?: UserPositionRaw[] | undefined,
        retryCount = 0
    ) => {
        if (!oldPositions || retryCount > 5) return mutate();

        const newPositions = await mutate();

        if (!newPositions?.length || newPositions.length === oldPositions.length) {
            await sleep(3000);
            updateUserPositions(oldPositions, retryCount + 1);
            return;
        }
    };

    useEffect(() => {
        if (delayComplete) {
            initialLoadUp = true;
        }
    }, [delayComplete]);

    return {
        userPositions: data,
        isLoading:
            ((!error && !data && !tokenDetailsError) ||
                (!initialLoadUp && !delayComplete)) &&
            !userPositionIdsError,
        // error: error || tokenDetailsError || userPositionIdsError,
        error,
        updateUserPositions,
    };
};

export default useUserPositions;
